import React from "react";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import DriveFileMove from "@mui/icons-material/DriveFileMove";
import Edit from "@mui/icons-material/Edit";
import Delete from "@mui/icons-material/Delete";
import Visibility from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import { Divider } from "@mui/material";
import { Share } from "@mui/icons-material";

const AssetMenu = ({
	anchorEl,
	onClose,
	onMove,
	onEdit,
	onViewDetails,
	onDelete,
	t,
	isWritter,
	isReviewer,
	isPublisher,
	onDownloadFile,
	isAccesUrl,
	canCreateAsset,
	canDeleteAsset,
	canEditAsset,
	fileType,
	canShare,
	onShare
}) => {
	const isAssetDownloadable =
		fileType === "documents" ||
		fileType === "images" ||
		fileType === "videos" ||
		fileType === "css";

	return (
		<Menu id="actions-asset" open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={onClose}>
			<MenuItem onClick={onViewDetails}>
				<Visibility fontSize="small" sx={{ mr: 1 }} />
				{t("ASSETS.ACTIONS.viewDetails")}
			</MenuItem>
			{isAssetDownloadable && (
				<MenuItem onClick={onDownloadFile}>
					<DownloadIcon fontSize="small" sx={{ mr: 1 }} />
					{t("ASSETS.ACTIONS.download")}
				</MenuItem>
			)}

			<MenuItem onClick={onShare} disabled={!canShare}>
				<Share fontSize="small" sx={{ mr: 1 }} />
				{t("SETTINGS.share")}
			</MenuItem>

			<Divider />

			<MenuItem onClick={onMove}>
				<DriveFileMove fontSize="small" sx={{ mr: 1 }} />
				{t("ASSETS.ACTIONS.move")}
			</MenuItem>
			{/** 
			 @description display only if the current user's role is isWritter or isReviewer 
			 */}
			{canEditAsset && (
				<MenuItem onClick={onEdit}>
					<Edit fontSize="small" sx={{ mr: 1 }} />
					{t("ASSETS.ACTIONS.edit")}
				</MenuItem>
			)}
			{/** 
			 @description display only if the current user's role is isReviewer 
			 */}
			{canDeleteAsset && (
				<>
					<Divider />
					<MenuItem onClick={onDelete} style={{ color: "red" }}>
						<Delete fontSize="small" sx={{ mr: 1 }} />
						{t("ASSETS.ACTIONS.delete")}
					</MenuItem>
				</>
			)}
		</Menu>
	);
};

export default AssetMenu;
